/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("common.column_settings", require("./rawicons/column_settings.icon.svg"));
IconRegistry.registerIcon("common.default_device", require("./rawicons/default_device.icon.svg"));
IconRegistry.registerIcon("common.firewall", require("./rawicons/firewall.icon.svg"));
IconRegistry.registerIcon("common.load_balancer", require("./rawicons/load_balancer.icon.svg"));
IconRegistry.registerIcon("common.router", require("./rawicons/router.icon.svg"));
IconRegistry.registerIcon("common.switch", require("./rawicons/switch.icon.svg"));
IconRegistry.registerIcon("common.wan_op", require("./rawicons/wan_op.icon.svg")); //old
IconRegistry.registerIcon("common.wan_optimizer", require("./rawicons/wan_op.icon.svg"));
IconRegistry.registerIcon("common.wlc", require("./rawicons/wlc.icon.svg")); //old
IconRegistry.registerIcon("common.collector", require("./rawicons/base_collector.svg"));
IconRegistry.registerIcon("common.controller", require("./rawicons/wlc.icon.svg"));
IconRegistry.registerIcon(
    "common.wan_access_point",
    require("./rawicons/wan_access_point.icon.svg")
);
IconRegistry.registerIcon("common.star", require("./rawicons/star.icon.svg"));
IconRegistry.registerIcon("common.star_open", require("./rawicons/star_open.icon.svg"));
IconRegistry.registerIcon("common.log_link", require("./rawicons/log_link.icon.svg"));
IconRegistry.registerIcon("common.results_link", require("./rawicons/results_link.icon.svg"));
IconRegistry.registerIcon("common.target_link", require("./rawicons/target_link.icon.svg"));
IconRegistry.registerIcon("common.skipped", require("./rawicons/skipped.icon.svg.js"));
IconRegistry.registerIcon("common.completed", require("./rawicons/completed.icon.svg.js"));
IconRegistry.registerIcon("common.edit", require("./rawicons/edit.icon.svg.js"));
IconRegistry.registerIcon("common.read_only", require("./rawicons/read_only.icon.svg.js"));
IconRegistry.registerIcon("common.warning", require("./rawicons/warning.icon.svg.js"));
IconRegistry.registerIcon("common.external_link", require("./rawicons/external_link.icon.svg.js"));
IconRegistry.registerIcon("common.download", require("./rawicons/download.icon.svg.js"));
IconRegistry.registerIcon("common.upload", require("./rawicons/upload.icon.svg.js"));
IconRegistry.registerIcon("common.pdf", require("./rawicons/pdf.icon.svg.js"));
IconRegistry.registerIcon("common.zip", require("./rawicons/external_link.icon.svg.js"));
IconRegistry.registerIcon("common.access_point", require("./rawicons/base_access_point.svg"));
IconRegistry.registerIcon("common.ups", require("./rawicons/ups.icon.svg"));
IconRegistry.registerIcon("common.hide", require("./rawicons/hide.icon.svg.js"));
IconRegistry.registerIcon(
    "common.console_server",
    require("./rawicons/console_server.icon.svg.js")
);
IconRegistry.registerIcon(
    "common.site_inheritnce_on",
    require("./rawicons/site_inheritance_on.svg")
);
IconRegistry.registerIcon(
    "common.site_inheritnce_off",
    require("./rawicons/site_inheritance_off.svg")
);

IconRegistry.registerIcon("common.medical_io_t", require("./rawicons/medical_iot.svg.js"));
